<template>
  <div>
    <label class="form-control-label">Versões do Relatórios</label>
    <multiselect
      v-model="selectedReportVersion"
      :options="reportVersions"
      :loading="loadingReportVersions"
      track-by="id"
      placeholder="Selecionar Versão de Relatório"
      :custom-label="({created_at, user_name}) => { return created_at ? `${$options.filters.formatDate(created_at, 'datetime')} - ${user_name}` : ''}"
    >
      <template #option="props">
        <div class="option__desc">
          <span class="text-muted font-weight-bold">{{ props.option.user_name }}</span><br>
          <span class="text-sm">{{ $options.filters.formatDate(props.option.created_at, 'datetime') }}</span><br>
          <span class="text-sm">{{ props.option.request_params }}</span>
        </div>
      </template>
    </multiselect>
    <base-button type="primary" class="mr-2 mt-2" @click="emit('generate-report', selectedReportVersion.report_data)">Exibir Dados Salvos</base-button>
    <base-button type="primary" class="mr-2 mt-2" @click="emit('save-report')">Salvar Dados</base-button>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted, defineEmits } from "vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import axios from "@/backend/axios/index.js";

const emit = defineEmits(["generate-report", "save-report"]);

const loadingReportVersions = ref(false)
const reportVersions = ref([])
const selectedReportVersion = ref({})

const props = defineProps({
  reportType: {
    type: String,
    required: true,
  },
})

onMounted(() => {
  getReportVersions();
});

const getReportVersions = async () => {
  try {
    loadingReportVersions.value = true
    const response = await axios.get(`/api/v2/report_versions/`, {
      params: {
        q: {
          goal_type: props.goal_type
        }
      }
    })

    reportVersions.value = response.data
  } catch (error) {
    console.warn("[ScheduleReportForm][getScheduleReportItems]", error);
  } finally {
    loadingReportVersions.value = false
  }
}
</script>

<style>
</style>
